import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BrandVoice = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 28 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <rect x="4.2" y="6.825" width="19.6" height="17.85" rx="4.3" fill="white" stroke={color} strokeWidth="1.4" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6126 8.82389C14.6126 8.43729 14.2992 8.12389 13.9126 8.12389C13.526 8.12389 13.2126 8.43729 13.2126 8.82389V16.7918C13.2126 17.1784 13.526 17.4918 13.9126 17.4918C14.2992 17.4918 14.6126 17.1784 14.6126 16.7918V8.82389ZM10.4126 9.7092C10.4126 9.32261 10.0992 9.0092 9.7126 9.0092C9.326 9.0092 9.0126 9.32261 9.0126 9.7092V15.9064C9.0126 16.293 9.326 16.6064 9.7126 16.6064C10.0992 16.6064 10.4126 16.293 10.4126 15.9064V9.7092ZM12.5126 11.0372C12.5126 10.6506 12.1992 10.3372 11.8126 10.3372C11.426 10.3372 11.1126 10.6506 11.1126 11.0372V14.5785C11.1126 14.9651 11.426 15.2785 11.8126 15.2785C12.1992 15.2785 12.5126 14.9651 12.5126 14.5785V11.0372ZM7.6126 11.6652C7.9992 11.6652 8.3126 11.9786 8.3126 12.3652V13.2505C8.3126 13.6371 7.9992 13.9505 7.6126 13.9505C7.226 13.9505 6.9126 13.6371 6.9126 13.2505V12.3652C6.9126 11.9786 7.226 11.6652 7.6126 11.6652ZM20.2126 11.6652C20.5992 11.6652 20.9126 11.9786 20.9126 12.3652V13.2505C20.9126 13.6371 20.5992 13.9505 20.2126 13.9505C19.826 13.9505 19.5126 13.6371 19.5126 13.2505V12.3652C19.5126 11.9786 19.826 11.6652 20.2126 11.6652ZM16.0126 10.3372C16.3992 10.3372 16.7126 10.6506 16.7126 11.0372V14.5785C16.7126 14.9651 16.3992 15.2785 16.0126 15.2785C15.626 15.2785 15.3126 14.9651 15.3126 14.5785V11.0372C15.3126 10.6506 15.626 10.3372 16.0126 10.3372ZM18.1126 9.0092C18.4992 9.0092 18.8126 9.32261 18.8126 9.7092V15.9064C18.8126 16.293 18.4992 16.6064 18.1126 16.6064C17.726 16.6064 17.4126 16.293 17.4126 15.9064V9.7092C17.4126 9.32261 17.726 9.0092 18.1126 9.0092Z"
          fill={color}
        />
        <path
          d="M9.3625 20.5625C9.3625 21.384 8.69652 22.05 7.875 22.05C7.05348 22.05 6.3875 21.384 6.3875 20.5625C6.3875 19.741 7.05348 19.075 7.875 19.075C8.69652 19.075 9.3625 19.741 9.3625 20.5625Z"
          fill="white"
          stroke={color}
          strokeWidth="1.4"
        />
        <path
          d="M21.6125 20.5625C21.6125 21.384 20.9465 22.05 20.125 22.05C19.3035 22.05 18.6375 21.384 18.6375 20.5625C18.6375 19.741 19.3035 19.075 20.125 19.075C20.9465 19.075 21.6125 19.741 21.6125 20.5625Z"
          fill="white"
          stroke={color}
          strokeWidth="1.4"
        />
        <path d="M14 6.125L21 3.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M11.375 20.5625H16.625" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
        <path d="M14 6.125L7 3.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    )
  },
)

export default BrandVoice
